import React, { useMemo } from 'react';
import {FuseNavigation} from '@fuse';
import clsx from 'clsx';
import {useSelector} from 'react-redux';
import useMtessHabilitado from 'app/services/ControlService/useMtessHabilitado';

// Entradas del menú que solo tienen sentido con la integración MTESS habilitada.
const ITEMS_MTESS = ['comunicacion', 'mtess-verify'];

function quitarItems(items, ids) {
    return items
        .filter(item => !ids.includes(item.id))
        .map(item => item.children ? { ...item, children: quitarItems(item.children, ids) } : item);
}

function Navigation(props)
{
    const navigation = useSelector(({fuse}) => fuse.navigation);
    const mtessHabilitado = useMtessHabilitado();

    const navigationVisible = useMemo(
        () => mtessHabilitado ? navigation : quitarItems(navigation, ITEMS_MTESS),
        [navigation, mtessHabilitado]
    );

    return (
        <FuseNavigation className={clsx("navigation", props.className)} navigation={navigationVisible} layout={props.layout} dense={props.dense}/>
    );
}

Navigation.defaultProps = {
    layout: "vertical"
};

export default Navigation;
